var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemove = function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "remove_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "remove_svg__remove"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 13a.97.97 0 0 1-.713-.287A.97.97 0 0 1 5 12q0-.424.287-.713A.97.97 0 0 1 6 11h12a.97.97 0 0 1 .712.287Q19 11.575 19 12c0 .425-.096.52-.288.713A.97.97 0 0 1 18 13z",
    className: "remove_svg__vector"
  }))));
};
export { SvgRemove as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5SZW1vdmU8L3RpdGxlPjxnIGNsYXNzPSJyZW1vdmUiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTYgMTNhLjk2Ny45NjcgMCAwIDEtLjcxMy0uMjg3QS45NjguOTY4IDAgMCAxIDUgMTJjMC0uMjgzLjA5Ni0uNTIuMjg3LS43MTNBLjk2Ny45NjcgMCAwIDEgNiAxMWgxMmEuOTcuOTcgMCAwIDEgLjcxMi4yODdjLjE5Mi4xOTIuMjg4LjQzLjI4OC43MTNzLS4wOTYuNTItLjI4OC43MTNBLjk2OC45NjggMCAwIDEgMTggMTNINloiIGNsYXNzPSJ2ZWN0b3IiLz48L2c+PC9zdmc+";